import React, { useContext } from 'react';
import * as R from 'ramda';
import { func } from 'prop-types';

// Components
import { Box } from '@mui/material';
import { WizardRowItem } from 'common';
import Buttons from '../../components/Buttons';
import InventoryOwnerAutoComplete from '../../components/InventoryOwnerAutoComplete.connector';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const SequenceStep1 = ({ next, prev }) => {
  const {
    data: { currentAffiliate, inventoryOwners = [] },
    setData,
  } = useContext(SequencingWizardContext);
  const continueDisabled = !inventoryOwners.length;

  const handleAdd = inventoryOwner =>
    setData(
      R.evolve({
        inventoryOwners: R.append(inventoryOwner),
        loadProducts: R.T,
        products: R.empty,
      })
    );

  const handleRemove = inventoryOwner =>
    setData(
      R.evolve({
        inventoryOwners: R.reject(R.equals(inventoryOwner)),
        loadProducts: R.T,
        products: R.empty,
      })
    );

  const handleOnMove = (idx, direction) => {
    const updatedArr = R.move(idx, idx + direction, inventoryOwners);
    setData(R.assoc('inventoryOwners', updatedArr));
  };

  const renderRow = (inventoryOwner, index) => (
    <WizardRowItem
      index={index}
      key={inventoryOwner.companyCustomerIdName}
      length={inventoryOwners.length}
      name={`${inventoryOwner.companyCustomerIdName} ${inventoryOwner.nameShort}`}
      onMove={handleOnMove}
      onRemove={() => handleRemove(inventoryOwner)}
      sequenceable
    />
  );

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
        }}
      >
        <InventoryOwnerAutoComplete
          autoClear
          currentAffiliate={currentAffiliate}
          onChange={handleAdd}
          title="Select one or more Inventory Owners and put them in your preferred order."
          without={inventoryOwners}
        />
        <Box flexGrow={1}>
          {!R.isEmpty(inventoryOwners) &&
            inventoryOwners.map((inventoryOwner, index) => renderRow(inventoryOwner, index))}
        </Box>
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        rightLabel="Continue"
      />
    </>
  );
};

SequenceStep1.propTypes = {
  next: func.isRequired,
  prev: func.isRequired,
};

export default SequenceStep1;
